import ABCyaPhaser from '@abcya/abcya_phaser'

export default class Creature extends Phaser.GameObjects.Container
{
    constructor(scene, t, i, m)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;

        this.type = t;
        this.ind = i;
        this.max = m;
        this.isOver = false;

        this.createCreature();
        this.moveCreature();
    };

    createCreature()
    {
        if(this.type == "bat"){
            const rando = Phaser.Math.Between(75, 400);

            this.body = ABCyaPhaser.Images.addImage(0, 0, "batBody", this);
            this.wingL = ABCyaPhaser.Images.addImage(this.body.x - 6, 0, "batWingL", this).setAngle(50);
            this.wingR = ABCyaPhaser.Images.addImage(this.body.x + 6, 0, "batWingR", this).setAngle(-50);

            this.setPosition(this.scene.mid.x*2 - rando, 300);
            this.setScale(0);
        }
    };

    moveCreature(){
        //create random points for the motion guide
        const randStart = Phaser.Math.Between(100, 900);
        const randEnd = Phaser.Math.Between(-200, 500);

        this.soundDelay = this.scene.time.delayedCall(500, ()=>{ABCyaPhaser.Audio.playOneShot("Flap_Flap_Flap", this.scene, .1)});

        //reset the X position of the cloud when it get to the other side. Tween across with a random time between 10-15 seconds
        if(this.type == "bat"){
            const rand = Phaser.Math.Between(100, 800) * this.ind;

            ABCyaPhaser.Tweens.addTween(this.wingL, 100, {angle:-100, yoyo:true, repeat:-1}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this.wingR, 100, {angle:100, yoyo:true, repeat:-1}, Phaser.Math.Easing.Linear);
            ABCyaPhaser.Tweens.addTween(this, 1500, {x:randStart, y:randEnd, scale:10, delay:rand}, Phaser.Math.Easing.Linear);

            this.fader = this.scene.time.delayedCall(rand + 1000, ()=>{this.fadeOut();});
        }
    };

    fadeOut(){
        //fade the creature out
        if(this.type == "bat"){
            ABCyaPhaser.Tweens.addTween(this, 500, {alpha:0}, Phaser.Math.Easing.Linear, ()=>{ this.destroyCreature(); });
        }
    };

    stopCreature(){
        //stop the creature's tweens
        if(this.type == "bat"){
            this.scene.tweens.killTweensOf(this.wingL);
            this.scene.tweens.killTweensOf(this.wingR);
        }
        this.scene.tweens.killTweensOf(this.body);
        this.scene.tweens.killTweensOf(this);

        this.fader?.remove();
        this.fader?.destroy();
        this.soundDelay?.remove();
        this.soundDelay?.destroy();
        this.creater?.remove();
        this.creater?.destroy();
    };

    destroyCreature(){
        //Destroy the creature
        this.stopCreature();

        if(this.type == "bat"){
            this.wingL.destroy();
            this.wingR.destroy();
        }
        this.body.destroy();

        if(!this.isOver){
            if(this.max == this.ind){
                this.creater = this.scene.time.delayedCall(Phaser.Math.Between(1000, 3000), ()=>{
                    this.scene.createCreatures(Phaser.Math.Between(1, 5));
                });
            }
        }
    };
}